import {atom} from 'jotai'

import {VIPProgram} from '../domain'

export const ProgramDetailAtom = atom<VIPProgram | null>(null)
export const PrevProgramDetailAtom = atom<VIPProgram | null>(null)
